import { render, staticRenderFns } from "./embed.vue?vue&type=template&id=2bf562f7"
import script from "./embed.vue?vue&type=script&lang=js"
export * from "./embed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports